export default __webpack_public_path__ + "static/media/checkIcon.d256b328.svg";